module.exports = __webpack_public_path__ + "img/card-contract-hover.09dc8e32.svg";